export const MultiRegionTracking = {
  MULTI_REGION_TOOLTIP_SHOWN: '[Top Bar] multi region tool tip shown',
  MULTI_REGION_REGION_CHANGED: '[Top Bar] multi region region switched',
  MULTI_REGION_TOOLTIP_CLOSED: '[Top Bar] multi region tool tip closed',
  MULTI_REGION_LEARN_MORE_CLICK: '[Top Bar] multi region learn more click',
  MULTI_REGION_DROPDOWN_CLICK: '[Top Bar] multi region dropdown click',
};
